import ManagerAvatar from '../ui/ManagerAvatar';
import { matchupOutcome } from '../../utils/predictionScorecard';

const OUTCOME = { correct: { glyph: '✓', label: 'Correct' }, missed: { glyph: '✗', label: 'Missed' }, tie: { glyph: '=', label: 'Tie' } };

function matchupTeams(matchup, teamsById) {
  return matchup.teamIds.map((teamId) => teamsById[teamId]).filter(Boolean);
}

// chances: { [matchupId]: { percent, band } } for weeks a registered win-probability model covered
// before kickoff (Week 4 on); null keeps each pick's original filed confidence text.
export default function MatchupRail({ matchups, teamsById, selectedId, onSelect, late = false, finalScores = null, chances = null }) {
  return (
    <section className="forecast-rail-section" aria-labelledby="forecast-board-title">
      <div className="forecast-shell">
        <div className="forecast-section-heading">
          <div>
            <p className="forecast-kicker">The board</p>
            <h2 id="forecast-board-title">Make the call.</h2>
          </div>
          <p>{late ? 'Projected points were captured after first kickoff; they are not live scores or pregame picks.' : 'Projected points are a pregame snapshot, not a live score.'}{chances && ' Each win chance comes from the point gap.'}</p>
        </div>
        <div className="forecast-rail" role="group" aria-label="Week matchup picks">
          {matchups.map((matchup, index) => {
            const [left, right] = matchupTeams(matchup, teamsById);
            if (!left || !right) return null;
            const winner = teamsById[matchup.winnerId];
            const active = matchup.id === selectedId;
            const outcome = matchupOutcome(matchup, finalScores);
            const chance = chances?.[matchup.id] || null;
            const tossUp = chance ? chance.band === 'Toss-up' : matchup.confidence === 'Toss-up';
            return (
              <button
                key={matchup.id}
                type="button"
                aria-pressed={active}
                className={`forecast-pick ${active ? 'is-active' : ''} ${tossUp ? 'forecast-pick--tossup' : ''} ${outcome ? `is-${outcome.status}` : ''}`}
                onClick={() => onSelect(matchup.id)}
              >
                <span className="forecast-pick__top"><span>Game {index + 1}</span>{chance ? <span className="forecast-pick__chance" data-band={chance.band}><span className="forecast-sr">Win chance for the pick: </span>{chance.percent}% · {chance.band}</span> : <span>{matchup.confidence}</span>}</span>
                <span className="forecast-pick__duel">
                  <span><ManagerAvatar name={left.manager} size="xs" /><b>{left.manager}</b></span>
                  <i>vs</i>
                  <span><ManagerAvatar name={right.manager} size="xs" /><b>{right.manager}</b></span>
                </span>
                <span className="forecast-pick__scores"><b className={winner?.id === left.id ? 'is-winner' : ''}>{left.score.toFixed(1)}</b><span>—</span><b className={winner?.id === right.id ? 'is-winner' : ''}>{right.score.toFixed(1)}</b></span>
                <span className="forecast-pick__footer">
                  <span className="forecast-pick__winner">Pick: {winner?.manager}</span>
                  {outcome && <span className={`forecast-pick__outcome is-${outcome.status}`}><span aria-hidden="true">{OUTCOME[outcome.status].glyph}</span> {OUTCOME[outcome.status].label}</span>}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
